import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { planFeedbackTransactionActionType } from '../../plan_feedback/builders/plan_feedback_transaction_type';
import { IConflictingSuggestionsModel } from '../models/conflicting_suggestions_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'performActionOnBlockedSuggestionsCommand',
    function performActionOnBlockedSuggestionsCommand(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngAPNotificationDelegate: INotificationDelegate
    ) {
      return defineCommandORM(
        'performActionOnBlockedSuggestionsCommand',
        (
          deferred,
          suggestedPlanId: number,
          resolutionIds: IConflictingSuggestionsModel['conflicting_resolution_ids'],
          action: planFeedbackTransactionActionType
        ) => {
          const apiParams = _4.map(resolutionIds, (resolutionId) => ({
            resolution: resolutionId,
            action
          }));
          const applySuggIndicator = 'apply-suggestion-indicator';
          ngAPNotificationDelegate.info({
            content: 'Applying acceptable suggestions...',
            name: applySuggIndicator
          });
          $http
            .post(`/academicplan/suggested_plan_resolution/${suggestedPlanId}/unblock/`, apiParams)
            .then((response) => {
              ngAPNotificationDelegate.dismissAlertByName(applySuggIndicator);
              ngAPNotificationDelegate.success('Successfully applied acceptable suggestions!');
              deferred.resolve();
            })
            .catch((error) => {
              ngAPNotificationDelegate.dismissAlertByName(applySuggIndicator);
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/commands/perform_action_on_blocked_suggestions_command.ts